import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPressVerse = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-emerald font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>PressVerse Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-emerald pl-4 mb-8">
          Last Updated: September 2026 — applies to PressVerse 1.2.2
        </p>
        <p>
          This document outlines the specific privacy practices for <strong>PressVerse</strong>. It serves as an addendum to the general MediaVerse Labs Privacy Policy, and matches the policy shipped inside the app under Help &amp; Support.
        </p>

        <h2>1. We do not run servers, and we do not collect your data</h2>
        <p>
          PressVerse is a desktop application. MediaVerse Labs operates no backend service for it. We do not receive, store or have any access to your books, your API keys, your Amazon account or your usage. There is no account to create and nothing to sign in to.
        </p>

        <h2>2. What is stored on your device</h2>
        <ul>
          <li><strong>Projects:</strong> your books, chapters, outlines and version history live in a local SQLite database in your Windows AppData folder.</li>
          <li><strong>Credentials:</strong> your API keys, and any saved Amazon KDP cookies, are encrypted at rest using the Windows Data Protection API (DPAPI), tied to your Windows user account.</li>
          <li><strong>Exports:</strong> finished PDF, EPUB and DOCX files and covers are written to the folder you choose — by default <em>Documents\PressVerse</em>.</li>
          <li><strong>Logs:</strong> a local rotating log file is kept for troubleshooting. It never leaves your device and does not record API keys or cookie values.</li>
        </ul>

        <h2>3. Third-Party AI Providers</h2>
        <p>
          When you trigger an AI feature — an outline, a chapter, the Literary Critic, niche research or cover art — PressVerse sends your prompt, the relevant book content and your API key directly to the provider you selected (OpenAI, Anthropic, Google Gemini, DeepSeek, Mistral or Stability AI) over HTTPS.
        </p>
        <ul>
          <li><strong>Bring your own key:</strong> your keys are yours. They are never sent to MediaVerse Labs and we never see your provider bill.</li>
          <li><strong>Only what you ask for:</strong> nothing is transmitted until you explicitly start a generation.</li>
          <li><strong>Provider policies:</strong> that exchange is governed by the privacy policy and terms of the provider you chose.</li>
        </ul>

        <h2>4. Amazon KDP publishing</h2>
        <p>
          If you use the KDP publishing feature, PressVerse reuses your existing signed-in browser session to act on kdp.amazon.com as you. Your Amazon username and password are never requested, seen or stored. Cookie values are used locally and are encrypted if saved.
        </p>

        <h2>5. Licensing</h2>
        <p>
          PressVerse is sold and licensed through the Microsoft Store. The Store handles your purchase and entitlement; the app contains no licence server of its own, performs no activation call and transmits no hardware identifier.
        </p>

        <h2>6. No Analytics</h2>
        <p>
          PressVerse contains no telemetry, no analytics SDK and no advertising. We don't know how many books you write or which genres you prefer. If the app crashes, the error is shown to you and written to the local log only.
        </p>

        <h2>7. Data retention and deletion</h2>
        <p>
          Your data lives on your device, so you control it. Delete individual projects from the Library, clear cached data from Settings, or uninstall the app. Uninstalling removes the application and leaves the books you exported to your Documents folder untouched.
        </p>

        <h2>8. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyPressVerse;
